import { margin } from '@aytm/app/stats/page/question-views/vk/components/chart/lib/constants'

export const countLabelSize = (text, fontSize = 17) => {
  if (!text) return { width: 0, height: 0 }

  const span = document.createElement('span')
  span.innerHTML = `w${text}w`
  Object.assign(span.style, {
    fontWeight: 'bold',
    color: 'black',
    fontFamily: 'Ubuntu, Calibri, Segoe, Helvetica, Arial',
    fontSize: `${fontSize}px`,
    lineHeight: '12px',
    position: 'absolute',
    top: '-1000px',
    right: '0',
    whiteSpace: 'nowrap',
    visibility: 'hidden'
  })

  document.body.appendChild(span)

  const width = span.offsetWidth
  const height = span.offsetHeight + span.offsetHeight / 3

  document.body.removeChild(span)

  return { width, height }
}

export const initScaleProjection =
  ({ xScale, yScale }) =>
  value => {
    return {
      x: margin.x + xScale(value),
      y: margin.y + yScale(value)
    }
  }
